import { jsx as l } from "react/jsx-runtime";
const c = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M8.173 2.761a10 10 0 1 1 7.654 18.478A10 10 0 0 1 8.173 2.761m2.444 5.3c.374-.124.804-.055 1.09.173l4 3.2c.39.313.39.82 0 1.132l-4 3.2c-.286.229-.716.297-1.09.173-.373-.124-.617-.415-.617-.739V8.8c0-.324.244-.615.617-.74",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  c as default
};
